import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RelocationReimagined from "./sections/RelocationReimagined";
import TheShiftStandard from "./sections/TheShiftStandard";
import RelocationSolutions from "./sections/RelocationSolutions";
import TheMovingBlueprint from "./sections/TheMovingBlueprint";
import ClientExperiences from "./sections/ClientExperiences";
import ReadyToMove from "./sections/ReadyToMove";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RelocationReimagined />
      <TheShiftStandard />
      <RelocationSolutions />
      <TheMovingBlueprint />
      <ClientExperiences />
      <ReadyToMove />
      <Footer />
    </div>;
}